import { useState } from "react";
import Image from "next/legacy/image";
import Link from "next/link";
import axios from "axios";

import PageHeader from "@/components/PageHeader";
import Seo from "@/components/seo";
import useMediaQuery from "src/lib/use-media-query";
import { getSpotifyToken } from "src/lib/spotify";

const PODCAST_IDS = [
  "67noaIcDmS3fPnKyGeg4dp",
  "3il0d30QvXpJvn5Rh3xW1c",
  "0PpILZeKTzVub4EjIlwMIz",
];

const SPOTIFY_ID_TO_SLUG_MAPPING = {
  "67noaIcDmS3fPnKyGeg4dp": "kvrx-sports-network",
  "3il0d30QvXpJvn5Rh3xW1c": "heavy-rotation",
  "0PpILZeKTzVub4EjIlwMIz": "kvrx-exclusives",
};


export async function getStaticProps() {
  const token = await getSpotifyToken();
  let podcasts = [];
  for (let i = 0; i < PODCAST_IDS.length; i++) {
    let res = await axios(
      `https://api.spotify.com/v1/shows/${PODCAST_IDS[i]}?market=US`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let data = await res.data;
    podcasts.push({
      id: data.id,
      episodeCount: data.episodes.total,
      image: data.images[0],
      name: data.name,
    });
  }

  return { props: { podcasts } };
}

function PodcastCard({ podcast }) {
  const isMobile = useMediaQuery("(max-width: 768px)")
  const [hover, setHover] = useState(false);

  const handleMouseEnter = () => {
    setHover(true);
  };
  const handleMouseLeave = () => {
    setHover(false);
  };

  return (
    <Link href={`/podcasts/${SPOTIFY_ID_TO_SLUG_MAPPING[podcast.id]}`}>

      <div
        className="card card-cover h-100 overflow-hidden text-white bg-dark rounded-5 shadow-lg"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Image
          src={podcast.image.url}
          alt={podcast.name}
          layout="fill"
          objectFit="cover"
        />
        <div
          className="d-flex flex-column h-100 p-5 pb-3 text-white text-shadow-1"
          style={
            // TODO: Make this CSS
            hover || isMobile
              ? {
                  backdropFilter: "blur(10px)",
                  background: "rgba(0,0,0,0.65)",
                }
              : {}
          }
        >
          <h2 className="pt-5 mt-5 mb-4 display-6 lh-1 fw-bold">
            {podcast.name}
          </h2>
          <div className="mt-auto">
            <b>
              <small>{podcast.episodeCount} Episodes</small>
            </b>
          </div>
        </div>
      </div>

    </Link>
  );
}

function PodcastsPage({ podcasts }) {
  return (
    <div className="container">
      <Seo title="Podcasts" />
      <PageHeader>Podcasts</PageHeader>
      <div className="row row-cols-1 row-cols-lg-3 align-items-stretch g-4 py-5">
        {podcasts.map((podcast) => (
          <div className="col" key={podcast.id}>
            <PodcastCard podcast={podcast} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default PodcastsPage;
